export const rooms = (state) => state.rooms
export const getRestaurantRooms = (state) => state.rooms